// Convert long to string date in format DD-MM-YYYY
export function longAsStringDate(time) {
    let date = new Date(time);
    let theYear = date.getFullYear();
    let theMonth = date.getMonth() + 1;
    let theDay = date.getDate();
    return(theDay + "-" + theMonth + "-" + theYear);
}

//Sorter by key
export function sorter(object, sortBy) {
    return object.sort(function (a, b){
        if (object.length > 1) {
            let varA = getValueByField(a, sortBy.key);
            let varB = getValueByField(b, sortBy.key);
            if (sortBy.asc) {
                return varA > varB ? 1 : -1;
            } else {
                return varB > varA ? 1 : -1;
            }
        }
    });
}

//Get value by field name
export function getValueByField(item, field) {
    let way = field.split('.');
    let value;
    for (let i = 0; i < way.length; i++) {
        let val = value ? value[way[i]] : item[way[i]];
        if (val) {
            value = val;
        } else {
            break;
        }
    }
    return value;
}